import { Expose } from 'class-transformer';
import { Point } from 'geojson';

import { SnModel } from '@lib/common/models';

export class SnSearchItemData extends SnModel {
  @Expose()
  public mark43Id: string;
}

export class SnSearchRmsItem extends SnModel {
  @Expose()
  public id: string;

  @Expose()
  public createdDatetime: string;

  @Expose()
  public updateDatetime: string;

  @Expose()
  public reportType: string;

  @Expose()
  public approvalStatus: string;

  @Expose()
  public ori: string;

  @Expose()
  public reportNumber: string;

  @Expose()
  public location: Point;

  @Expose()
  public narrative: string;

  @Expose()
  public summaryNarrative: string;

  @Expose()
  public hyperlink: string;

  @Expose()
  public address: string;

  @Expose()
  public lon: number;

  @Expose()
  public lat: number;

  @Expose()
  public geometry: Point;

  @Expose()
  public data: SnSearchItemData;

  @Expose()
  public incidentType: string;

  constructor(data: Partial<SnSearchRmsItem> = {}) {
    super();
    this.fromJSON(data);
  }
}
